import React from 'react';
import styles from './tv-guide.module.scss';
import testIds from '@smart-tv/e2e/shared/variables';
import Image from '@smart-tv/components/image';
import { TvGuideChannel } from '@smart-tv/pages/tv-guide/types';
import TvGuideDayViewContext from '../utils/tv-guide-day-view-context';

interface Props {
  channels: TvGuideChannel[];
}

const TvGuideChannels: React.FC<Props> = (props: Props) => {
  const { channels } = props;
  const { scaledConstants } = React.useContext(TvGuideDayViewContext);

  return (
    <div className={styles['tv-guide-channels']}>
      {channels.map((channel, channelIndex) => (
        <div
          className={styles['tv-guide-channels__channel']}
          key={channelIndex}
          data-testid={testIds.tvGuide.grid.channelItem}
        >
          <Image
            alt={`${channel.name}'s logo`}
            title={channel.name}
            src={channel.icon}
            width={scaledConstants.channelWidth}
            visibleByDefault={true}
          />
        </div>
      ))}
    </div>
  );
};

export default React.memo(TvGuideChannels);
